export default __webpack_public_path__ + "static/media/bannerBg.a473ceff.webp";